export default {
  hasChildIndicator: false,
  DIYRelationType: [
    { value: 'high', label: 'Estou sempre botando a mão na massa!' },
    { value: 'medium', label: 'Gosto, mas não possuo habilidade' },
    { value: 'low', label: 'Não tenho interesse' }
  ],
  homeDecorKnowledgeLevel: [
    { value: 'high', label: ' Sim, gosto muito de manter minha casa bem decorada' },
    { value: 'low', label: 'Sim, mas não conheço muito sobre o assunto' },
    { value: 'none', label: 'Não tenho interesse' }
  ],
  interestAreaName: [
    {
      isSelected: false,
      label: 'Banheiros',
      icon: 'banheiro',
      value: 'bathroom',
      order: 1
    },
    {
      isSelected: false,
      label: 'Cozinhas e Áreas de Serviço',
      icon: 'cozinha',
      value: 'kitchen',
      order: 2
    },
    {
      isSelected: false,
      label: 'Pisos e Revestimentos',
      icon: 'piso',
      value: 'floor',
      order: 3
    },
    {
      isSelected: false,
      label: 'Organização da Casa',
      icon: 'cabide',
      value: 'organization',
      order: 4
    },
    {
      isSelected: false,
      label: 'Tintas e Acessórios',
      icon: 'pincel',
      value: 'paints',
      order: 5
    },
    {
      isSelected: false,
      label: 'Segurança e Comunicação',
      icon: 'camera',
      value: 'security',
      order: 6
    },
    {
      isSelected: false,
      label: 'Manutenção e Limpeza de Casa',
      icon: 'limpeza',
      value: 'maintenance',
      order: 7
    },
    {
      isSelected: false,
      label: 'Iluminação',
      icon: 'lampada',
      value: 'lighting',
      order: 8
    },
    {
      isSelected: false,
      label: 'Ferramentas',
      icon: 'ferramentas',
      value: 'tools',
      order: 9
    },
    {
      isSelected: false,
      label: 'Materiais Hidráulicos',
      icon: 'torneira',
      value: 'hydraulic',
      order: 10
    },
    {
      isSelected: false,
      label: 'Madeiras',
      icon: 'madeira',
      value: 'wood',
      order: 11
    },
    {
      isSelected: false,
      label: 'Climatização e Ventilação',
      icon: 'ventilacao',
      value: 'ventilation',
      order: 12
    },
    {
      isSelected: false,
      label: 'Ferragens',
      icon: 'dobradica',
      value: 'ironmongery',
      order: 13
    },
    {
      isSelected: false,
      label: 'Materiais de Construção',
      icon: 'tijolos',
      value: 'construction',
      order: 14
    },
    {
      isSelected: false,
      label: 'Materiais Elétricos',
      icon: 'tomada',
      value: 'electrical',
      order: 15
    },
    {
      isSelected: false,
      label: 'Jardim e Varanda',
      icon: 'plantas',
      value: 'garden',
      order: 16
    },
    {
      isSelected: false,
      label: 'Portas, Janelas e Portões',
      icon: 'porta',
      value: 'door',
      order: 17
    },
    {
      isSelected: false,
      label: 'Decoração',
      icon: 'quadro',
      value: 'decoration',
      order: 18
    },
    {
      isSelected: false,
      label: 'Tapetes',
      icon: 'tapete',
      value: 'carpet',
      order: 19
    }
  ]
}
